const prefix = 'filter_builder/'

export const ActionTypes = {
  RECEIVE_CONTACT_PROPERTIES: `${prefix}RECEIVE_CONTACT_PROPERTIES`,
  RECEIVE_EVENT_PROPERTIES: `${prefix}RECEIVE_EVENT_PROPERTIES`,
  RECEIVE_PLAYBOOKS: `${prefix}RECEIVE_PLAYBOOKS`,
  RECEIVE_PLAYBOOK_EVENTS: `${prefix}RECEIVE_PLAYBOOK_EVENTS`,
  RECEIVE_TAGS: `${prefix}RECEIVE_TAGS`,
  RETURN_TO_PREVIOUS_VIEW: `${prefix}RETURN_TO_PREVIOUS_VIEW`,
  ADD_NEW_FILTER: `${prefix}ADD_NEW_FILTER`,
  ADD_NEW_GROUP: `${prefix}ADD_NEW_GROUP`,
  EDIT_FILTER_PROPERTY: `${prefix}EDIT_FILTER_PROPERTY`,
  EDIT_FILTER_VALUE: `${prefix}EDIT_FILTER_VALUE`,
  RESET_FILTER_AND_GROUP_INDEX: `${prefix}RESET_FILTER_AND_GROUP_INDEX`,
  APPLY_FILTER: `${prefix}APPLY_FILTER`,
  CHANGE_VIEW: `${prefix}CHANGE_VIEW`,
  SET_PLAYBOOK: `${prefix}SET_PLAYBOOK`,
  CHANGE_SEGMENT: `${prefix}CHANGE_SEGMENT`,
  CHANGE_FILTER_GROUP: `${prefix}CHANGE_FILTER_GROUP`,
  CHANGE_FILTER_INDEX: `${prefix}CHANGE_FILTER_INDEX`,
  SAVE_SEGMENT: `${prefix}SAVE_SEGMENT`,
  CLOSE_FILTER_BUILDER: `${prefix}CLOSE_FILTER_BUILDER`
}

export const receiveContactProperties = properties => {
  return {
    type: ActionTypes.RECEIVE_CONTACT_PROPERTIES,
    properties
  }
}

export const receiveEventProperties = properties => {
  return {
    type: ActionTypes.RECEIVE_EVENT_PROPERTIES,
    properties
  }
}

export const receivePlaybooks = playbooks => {
  return {
    type: ActionTypes.RECEIVE_PLAYBOOKS,
    playbooks
  }
}

export const receivePlaybookEvents = playbookEvents => {
  return {
    type: ActionTypes.RECEIVE_PLAYBOOK_EVENTS,
    playbookEvents
  }
}

export const receiveTags = tags => {
  return {
    type: ActionTypes.RECEIVE_TAGS,
    tags
  }
}

export const returnToPreviousView = () => {
  return {
    type: ActionTypes.RETURN_TO_PREVIOUS_VIEW
  }
}

export const addNewFilter = groupIndex => {
  return {
    type: ActionTypes.ADD_NEW_FILTER,
    groupIndex
  }
}

export const addNewGroup = () => {
  return {
    type: ActionTypes.ADD_NEW_GROUP
  }
}

export const editFilterProperty = ({ groupIndex, filterIndex }) => {
  return {
    type: ActionTypes.EDIT_FILTER_PROPERTY,
    groupIndex,
    filterIndex
  }
}

export const editFilterValue = ({ groupIndex, filterIndex }) => {
  return {
    type: ActionTypes.EDIT_FILTER_VALUE,
    groupIndex,
    filterIndex
  }
}

export const resetFilterAndGroupIndex = () => {
  return {
    type: ActionTypes.RESET_FILTER_AND_GROUP_INDEX,
  }
}

export const applyFilter = () => {
  return {
    type: ActionTypes.APPLY_FILTER,
  }
}

export const changeView = view => {
  return {
    type: ActionTypes.CHANGE_VIEW,
    view
  }
}

export const setPlaybook = playbook => {
  return {
    type: ActionTypes.SET_PLAYBOOK,
    playbook
  }
}

export const changeSegment = segment => {
  return {
    type: ActionTypes.CHANGE_SEGMENT,
    segment
  }
}

export const changeFilterGroup = groupIndex => {
  return {
    type: ActionTypes.CHANGE_FILTER_GROUP,
    groupIndex
  }
}

export const changeFilterIndex = filterIndex => {
  return {
    type: ActionTypes.CHANGE_FILTER_INDEX,
    filterIndex
  }
}

export const saveSegment = () => {
  return {
    type: ActionTypes.SAVE_SEGMENT
  }
}

export const closeFilterBuilder = () => {
  return {
    type: ActionTypes.CLOSE_FILTER_BUILDER
  }
}